import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/Text';

export default function WaitingForServer({ text }: { text: string }) {
  return (
    <div className="absolute inset-0 flex h-full flex-col items-center justify-center">
      <div className="dark:bg-gray-90 flex flex-col items-center gap-4 rounded-2xl bg-white p-4 lg:p-6">
        <Loading
          className="text-green h-10 w-10"
          trackClassName="stroke-gray-30"
        />
        <Text as="p" variant="studio/body/medium/md">
          {text}
        </Text>
      </div>
    </div>
  );
}
